import { Stack, Typography, Sheet, Ul, UlItem } from "@financeable-com-au/financeable-ui";

const Status = () => {
  return (
    <Stack flexDirection="column" justifyContent="flex-start" alignItems="center" height="100vh" rowGap={10}>
      <Stack textAlign="center" paddingTop={10}>
        <Typography level="title-lg" paddingBottom={4}>
          Outage Status
        </Typography>
        <Typography level="body-md">
          We are experiencing some technical issues due to upstream providers.
        </Typography>
      </Stack>
      <Sheet color="neutral" variant="outlined" borderRadius="md" sx={{ width: "50vw" }}>
        <Typography level="title-sm" paddingBottom={4}>
          The following services are currently impacted:
        </Typography>
        <Ul>
          <UlItem>Users are not able to navigate to the login page</UlItem>
          <UlItem>Users are not able to log in to the platform</UlItem>
        </Ul>
      </Sheet>
    </Stack>
  );
};

export { Status };
